const ruzyAiData = {
  hero: {
    badge: 'YAPAY ZEKA DESTEKLİ',
    badge_en: 'AI-POWERED',
    title: 'RUZY AI',
    subtitle: 'Bilgi Güvenliği Yönetiminde Yapay Zeka Asistanınız',
    subtitle_en: 'Your AI Assistant in Information Security Management',
    description: 'RUZY AI, ISO 27001 uyumluluk süreçlerinizi hızlandıran, akıllı öneriler sunan ve manuel iş yükünüzü azaltan yapay zeka destekli asistanınızdır.',
    description_en: 'RUZY AI is your AI-powered assistant that accelerates your ISO 27001 compliance processes, provides intelligent recommendations, and reduces your manual workload.',
  },

  stats: [
    { value: '%80', label: 'Zaman Tasarrufu', label_en: 'Time Savings' },
    { value: '10x', label: 'Daha Hızlı', label_en: 'Faster' },
    { value: '%95', label: 'Doğruluk', label_en: 'Accuracy' },
    { value: '7/24', label: 'Kullanılabilir', label_en: 'Available' },
  ],

  features: [
    {
      id: 'kontrol-onerisi',
      title: 'Akıllı Kontrol Önerisi',
      title_en: 'Smart Control Suggestions',
      description: 'Envanter varlıklarınıza göre ISO 27001 Ek A kontrollerini otomatik olarak önerir. Her varlık için en uygun güvenlik kontrollerini belirler.',
      description_en: 'Automatically suggests ISO 27001 Annex A controls based on your inventory assets. Identifies the most appropriate security controls for each asset.',
      icon: 'MdLightbulb',
      color: '#2a9d8f',
      capabilities: [
        { text: 'Varlık türüne göre kontrol eşleştirme', text_en: 'Control matching by asset type' },
        { text: 'Risk seviyesine göre önceliklendirme', text_en: 'Prioritization by risk level' },
        { text: '93 ISO kontrolü ile tam uyumluluk', text_en: 'Full compliance with 93 ISO controls' },
        { text: 'Boşluk analizi ve öneriler', text_en: 'Gap analysis and recommendations' },
      ],
      example: {
        title: 'Örnek Kullanım',
        title_en: 'Example Usage',
        input: 'Yeni bir veritabanı sunucusu eklediniz',
        input_en: 'You added a new database server',
        output: 'RUZY AI önerdi: A.8.1 (Kullanıcı uç noktası güvenliği), A.8.9 (Yapılandırma yönetimi), A.8.13 (Bilgi yedekleme), A.8.15 (Günlük kaydı)',
        output_en: 'RUZY AI suggested: A.8.1 (User endpoint security), A.8.9 (Configuration management), A.8.13 (Information backup), A.8.15 (Logging)',
      },
    },
    {
      id: 'risk-onerisi',
      title: 'Risk Analizi ve Önerisi',
      title_en: 'Risk Analysis & Suggestions',
      description: 'Varlıklarınızı analiz ederek potansiyel riskleri otomatik olarak tanımlar, risk tedavi stratejileri önerir ve önceliklendirme yapar.',
      description_en: 'Automatically identifies potential risks by analyzing your assets, suggests risk treatment strategies, and prioritizes them.',
      icon: 'MdWarning',
      color: '#e76f51',
      capabilities: [
        { text: 'Otomatik risk tanımlama', text_en: 'Automatic risk identification' },
        { text: 'CIA etkisi hesaplama', text_en: 'CIA impact calculation' },
        { text: 'Tedavi stratejisi önerisi', text_en: 'Treatment strategy recommendations' },
        { text: 'Trend analizi ve tahmin', text_en: 'Trend analysis and prediction' },
      ],
      example: {
        title: 'Örnek Kullanım',
        title_en: 'Example Usage',
        input: 'CRM yazılımı için risk analizi istediniz',
        input_en: 'You requested risk analysis for CRM software',
        output: 'RUZY AI tanımladı: Veri sızıntısı riski (Yüksek), Yetkisiz erişim riski (Orta), Hizmet kesintisi riski (Düşük). Önerilen tedavi: Şifreleme, erişim kontrolü, yedekleme.',
        output_en: 'RUZY AI identified: Data breach risk (High), Unauthorized access risk (Medium), Service disruption risk (Low). Suggested treatment: Encryption, access control, backup.',
      },
    },
    {
      id: 'politika-olusturma',
      title: 'Otomatik Politika Oluşturma',
      title_en: 'Automatic Policy Generation',
      description: 'ISO 27001 gereksinimlerine uygun politika ve prosedür taslakları oluşturur. Organizasyonunuza özel içerikler üretir.',
      description_en: 'Creates policy and procedure drafts compliant with ISO 27001 requirements. Generates content specific to your organization.',
      icon: 'MdDescription',
      color: '#264653',
      capabilities: [
        { text: 'Şablon tabanlı politika üretimi', text_en: 'Template-based policy generation' },
        { text: 'Organizasyona özel içerik', text_en: 'Organization-specific content' },
        { text: 'Versiyon kontrolü entegrasyonu', text_en: 'Version control integration' },
        { text: 'Çoklu dil desteği', text_en: 'Multi-language support' },
      ],
      example: {
        title: 'Örnek Kullanım',
        title_en: 'Example Usage',
        input: '"Parola Politikası" oluşturması istediniz',
        input_en: 'You requested creation of "Password Policy"',
        output: 'RUZY AI oluşturdu: 12 karakterli minimum uzunluk, karmaşıklık kuralları, 90 günlük geçerlilik, önceki 10 parolanın tekrar kullanım yasağı ile kapsamlı politika taslağı.',
        output_en: 'RUZY AI created: Comprehensive policy draft with 12-character minimum length, complexity rules, 90-day validity, prohibition of reusing last 10 passwords.',
      },
    },
    {
      id: 'egitim-icerigi',
      title: 'Eğitim İçeriği Oluşturma',
      title_en: 'Training Content Creation',
      description: 'Bilgi güvenliği farkındalık eğitimleri için özelleştirilmiş içerikler, sunumlar ve quiz soruları oluşturur.',
      description_en: 'Creates customized content, presentations, and quiz questions for information security awareness training.',
      icon: 'MdSchool',
      color: '#e9c46a',
      capabilities: [
        { text: 'Role özel eğitim modülleri', text_en: 'Role-specific training modules' },
        { text: 'İnteraktif quiz soruları', text_en: 'Interactive quiz questions' },
        { text: 'Senaryo tabanlı öğrenme', text_en: 'Scenario-based learning' },
        { text: 'Güncel tehdit bilgilendirmesi', text_en: 'Current threat information' },
      ],
      example: {
        title: 'Örnek Kullanım',
        title_en: 'Example Usage',
        input: 'Finans departmanı için phishing eğitimi istediniz',
        input_en: 'You requested phishing training for finance department',
        output: 'RUZY AI oluşturdu: Finansal dolandırıcılık senaryoları, sahte fatura örnekleri, BEC (Business Email Compromise) tanıma teknikleri ve 15 soruluk değerlendirme testi.',
        output_en: 'RUZY AI created: Financial fraud scenarios, fake invoice examples, BEC (Business Email Compromise) recognition techniques, and 15-question assessment test.',
      },
    },
    {
      id: 'denetim-plani',
      title: 'Denetim Planı Yazma',
      title_en: 'Audit Plan Writing',
      description: 'İç denetim programınız için kapsamlı denetim planları, kontrol listeleri ve soru setleri hazırlar.',
      description_en: 'Prepares comprehensive audit plans, checklists, and question sets for your internal audit program.',
      icon: 'MdFactCheck',
      color: '#f4a261',
      capabilities: [
        { text: 'Risk tabanlı denetim planlaması', text_en: 'Risk-based audit planning' },
        { text: 'Özelleştirilebilir kontrol listeleri', text_en: 'Customizable checklists' },
        { text: 'Denetim soruları üretimi', text_en: 'Audit question generation' },
        { text: 'Zaman ve kaynak tahmini', text_en: 'Time and resource estimation' },
      ],
      example: {
        title: 'Örnek Kullanım',
        title_en: 'Example Usage',
        input: 'A.8 Teknolojik kontroller için iç denetim planı istediniz',
        input_en: 'You requested internal audit plan for A.8 Technological controls',
        output: 'RUZY AI hazırladı: 34 kontrol için detaylı denetim programı, her kontrol için 3-5 doğrulama sorusu, tahmini 5 günlük denetim süresi, kanıt toplama rehberi.',
        output_en: 'RUZY AI prepared: Detailed audit program for 34 controls, 3-5 verification questions per control, estimated 5-day audit duration, evidence collection guide.',
      },
    },
    {
      id: 'yonetici-rapor',
      title: 'Yönetici Özet Raporu',
      title_en: 'Executive Summary Report',
      description: 'Üst yönetim için BGYS durumunu özetleyen, anlaşılır ve aksiyonlanabilir raporlar oluşturur.',
      description_en: 'Creates understandable and actionable reports summarizing ISMS status for senior management.',
      icon: 'MdSummarize',
      color: '#2a9d8f',
      capabilities: [
        { text: 'Otomatik veri toplama', text_en: 'Automatic data collection' },
        { text: 'Görsel grafikler ve trendler', text_en: 'Visual charts and trends' },
        { text: 'Öncelikli aksiyon önerileri', text_en: 'Priority action recommendations' },
        { text: 'Yönetim gözden geçirme desteği', text_en: 'Management review support' },
      ],
      example: {
        title: 'Örnek Kullanım',
        title_en: 'Example Usage',
        input: 'Q1 2025 için yönetim gözden geçirme raporu istediniz',
        input_en: 'You requested management review report for Q1 2025',
        output: 'RUZY AI oluşturdu: Risk durumu özeti (%15 azalma), kontrol uygulaması ilerlemesi (%78), 3 kritik bulgu ve çözüm önerileri, gelecek çeyrek için 5 öncelikli aksiyon.',
        output_en: 'RUZY AI created: Risk status summary (15% reduction), control implementation progress (78%), 3 critical findings and resolution recommendations, 5 priority actions for next quarter.',
      },
    },
  ],

  howItWorks: [
    { step: 1, title: 'Veri Analizi', title_en: 'Data Analysis', description: 'RUZY AI, sistemdeki tüm varlıkları, riskleri ve kontrolleri analiz eder.', description_en: 'RUZY AI analyzes all assets, risks, and controls in the system.', icon: 'MdAnalytics' },
    { step: 2, title: 'Bağlam Anlama', title_en: 'Context Understanding', description: 'Organizasyonunuzun sektörü, büyüklüğü ve risk iştahını anlar.', description_en: 'Understands your organization\'s sector, size, and risk appetite.', icon: 'MdPsychology' },
    { step: 3, title: 'Akıllı Öneri', title_en: 'Smart Suggestion', description: 'ISO 27001 standartlarına uygun, özelleştirilmiş öneriler sunar.', description_en: 'Provides customized recommendations compliant with ISO 27001 standards.', icon: 'MdTipsAndUpdates' },
    { step: 4, title: 'Sürekli Öğrenme', title_en: 'Continuous Learning', description: 'Geri bildirimlerinizle kendini geliştirir ve daha iyi sonuçlar üretir.', description_en: 'Improves itself with your feedback and produces better results.', icon: 'MdAutorenew' },
  ],

  benefits: [
    { title: 'Zaman Tasarrufu', title_en: 'Time Savings', description: 'Manuel süreçleri otomatize ederek saatlerinizi kurtarın', description_en: 'Save hours by automating manual processes', icon: 'MdTimer' },
    { title: 'Tutarlılık', title_en: 'Consistency', description: 'Her seferinde tutarlı ve standartlara uygun çıktılar', description_en: 'Consistent and standards-compliant outputs every time', icon: 'MdBalance' },
    { title: 'Uzmanlık', title_en: 'Expertise', description: 'ISO 27001 bilgi birikimini yapay zeka ile birleştirin', description_en: 'Combine ISO 27001 expertise with artificial intelligence', icon: 'MdWorkspacePremium' },
    { title: 'Ölçeklenebilirlik', title_en: 'Scalability', description: 'Organizasyon büyüdükçe AI de sizinle büyür', description_en: 'AI grows with you as your organization scales', icon: 'MdTrendingUp' },
  ],
};

export default ruzyAiData;
